import React, { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import { isMobile } from "react-device-detect";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import SharedTopBar from "./components/SharedTopBar";
import NotAllowed from "../../components/NotAllowed";
import ThumbnailList from "../StudyViewer/Components/Thumbnail/ThumbnailList";
import ViewportLayout from "../StudyViewer/Components/Viewport/ViewportLayout";
import MobileToolbar from "../StudyViewer/Components/Toolbar/MobileToolbar";
import { performResize } from "../StudyViewer/helpers/CornerstoneViewportService";
import { resizeViewport } from "../StudyViewer/helpers/CornerstoneViewportService";
import { initialize, getAugToolGroup, purgeCache } from "../StudyViewer/helpers/CornerstoneService";
import { NONXRAYMODALITIES, SHARED_VIEWER, DEFAULT_TOOL } from "../../constants/Constants";
import {
  PanTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";
import ContextMenu from "../StudyViewer/helpers/ContextMenu";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import { t } from "i18next";
import { getAdvanceViewerUrl, validateSharePassword } from "../../service/StudyViewerService";
import "./styles.css";
import AdvanceViewerIframe from "./components/AdvanceViewerIframe";
import loaderContext from "../../context/loader/LoaderContext";
import AlertSuccessModal from "../../components/AlertSuccessModal/AlertSuccessModal";
import MobileOverlayBottomSheet from "../StudyViewer/Components/Overlays/MobileOverlayBottomSheet";
import ViewerPage from "./components/ViewerPage";
import SeriesStackScrollMouseWheelTool from "../StudyViewer/helpers/SeriesStackScrollMouseWheelTool";
import ShortcutKeyModal from "../StudyViewer/Components/ShortcutKeyModal/ShortcutKeyModal";
import { setInvert, FlipHorizontally, FlipVertically, getViewport } from "../StudyViewer/helpers/CornerstoneViewportService";
import { resetVOILUTRange, setVOILUTRange } from "../StudyViewer/helpers/WindowLevelUtility";
import ThumbnailContext from '../../context/studyviewer/ThumbnailContext';
import ModalHeader from "../../components/Modal/ModalHeader";
import ModalFooter from "../../components/Modal/ModalFooter";
import ShareStudyLinkPasswordValidateBody from "../StudyList/components/Actions/ShareStudyLinkPasswordValidateBody";
import ModalMain from "../../components/Modal/ModalMain";
import { useFormik } from "formik";
import { use } from "react";
import { getEnv } from '../../helpers/EnvHelper';

const SharedStudyViewer = () => {
  const [searchParams] = useSearchParams();
  const [advanceViewerAvailable, setAdvanceViewerAvailable] = useState(false);
  const [isLinkAuthenticated, setIsLinkAuthenticated] = useState(false);
  const [advanceViewer, setAdvanceViewer] = useState(false);
  const [advanceViewerUrl, setAdvanceViewerUrl] = useState("");
  const [vdcPlatform, setVDCPlatform] = useState(
    getEnv("REACT_APP_VDC_PLATFORM") === "true" ? true : false
  );
  const [viewerReadyToLoad, setViewerReadyToLoad] = useState(false);
  const [advanceStudyURL, setAdvanceStudyURL] = useState("");
  const [basicStudyURL, setBasicStudyURL] = useState("");
  const [basicToken, setBasicToken] = useState("");
  const [cornerstoneInitialized, setCornerstoneInitialized] = useState(false);
  const [initialVOIRange, setInitialVOIRange] = useState(null);

    const [isLoading, setIsLoading] = useState(true); // controls password UI
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState("");


  const {
    fetchSharedStudyData,
    checkBypass,
    checkPassword,
    isBypassAllowed,
    isPasswordValid,
    setSharedViewer,
    patientStudyData,
    studyData,
    priorStudyData,
    dataGathered,
    setViewerOpacity,
    isAccessAllowed,
    setIsAccessAllowed,
    notAllowedMessage,
    setNotAllowedMessage,
    viewerOpacity,
    studyModality,
    aiProcessed,
    sharedDefaultViewer,
    setSharedDefaultViewer,
    sharedAdvanceViewerURL,
    showSharedViewer, setShowSharedViewer,
    isOutlineEnabled,
    isHeatMapEnabled,
    showSharedTopBar,
    showShortcutModal,
    setPrefetchPaused,
    reportMenu,
    setReportMenu,
    seriesMenu,
    setSeriesMenu,
    isLandscape,
  } = useContext(studyviewerContext);

  const {
    setAlertSuccessModal,
    alertSuccessModal,
  } = useContext(studyReportContext);

  const {
    isMPRActive,
    isCompareActive,
    contextMenuOpen,
    isUserInfoClicked,
    viewportSeriesData,
    seriesScrollCallback,
    viewportOldState,
    activeViewportIndex,
    activeTool,
    setActiveTool,
    setPreviousActiveTool,
    activeMPRTool,
    handleDefaultToolChange,
    setPreviousActiveMPRTool,
    setViewportSeriesData,
    togglePrimaryMouseAssignmentForTool,
    imageLoadedOnViewport,
  } = useContext(ViewportContext);
  const {
    activeThumbnailIndex,
    activeStudyId,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);

  let switchViewer = searchParams.get("switchViewer");
  let openViewer = searchParams.get("openViewer");
  let isActiveDataParam = searchParams.get("isActiveData");
  const location = useLocation();
  const currentUrl = window.location.href;

  const initializeCornerstone = async () => {
    try {
      await initialize(seriesScrollCallback);
      setCornerstoneInitialized(true);
    } catch (error) {
      console.log("*************************************")
      console.log(error);
      window.alert(
        "Viewer is unable to perform the action. Refresh the page to try again. If the issue persists, connect with the support team."
      );
    }
  };

  const getStudyData = async () => {
    if (!cornerstoneInitialized) {
      await initializeCornerstone();
    }
    await fetchSharedStudyData(
      searchParams.get("id"),
      switchViewer,
      openViewer,
      isActiveDataParam
    );
    // if(switchViewer == "true") {
    setLoaderRunning(false);
    // }
  };

  const openReportMenu = () => {
    console.trace("openReportMenu called from:");
    setViewerOpacity(0.1);
    setTimeout(() => {
      setReportMenu((prevFlag) => !prevFlag);
      setSeriesMenu(false);
    }, 100);
    setTimeout(() => {
      performResize();
    }, 500);
  };
  const leftSidePanelRef = useRef(null);
  const elementRef = useRef(null);
  const setLeftSidePanelEffect = useRef(false);
  const setInitialPanel = useRef(true);

  const openSeriesMenu = () => {
    if (!isMobile) {
      setViewerOpacity(0.1);
    }
    setTimeout(() => {
      setSeriesMenu(!seriesMenu);
      setReportMenu(false);
    }, 100);
    setTimeout(() => {
      if (!isMobile) {
        performResize();
        setViewerOpacity(1);
      }
    }, 500);
  };
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--topbar-container-height",
      isMobile ? "50px" : (isLandscape ? "30px" : "90px")
    );
    return () => {
      document.documentElement.style.removeProperty("--topbar-container-height");
    };
  }, [isMobile, isLandscape]);

  const handlePasswordSubmit = async (password) => {
    setAuthError("");
    setIsLoading(true);

    try {
      const res = await validateSharePassword(basicToken, password, true);
      if (res?.status === 200) {
       const isValid = res?.data?.data === true;
      
      if (isValid) {
        
        // setViewerReadyToLoad(true);
        // setLoaderRunning(false);
        // you can optionally hide the auth UI now
        setIsLinkAuthenticated(true);
      } else {
        setLoaderRunning(false);
        setAuthError("Invalid password. Please try again.");
      }
      } else {
        setLoaderRunning(false);
        setAuthError("Unable to Validate Password. Please try again.");
      }

    } catch (e) {
      console.error("Password validation failed:", e);
      setLoaderRunning(false);
      setAuthError("Could not validate password. Please try again.");
    }
  };

  const openSharedStudyViewerAfterAuth = async () => {
    setSharedViewer(true);
    setLoaderRunning(true);
    ref.current.continuousStart();
    if (getEnv("REACT_APP_VDC_PLATFORM") === "true") {
      getStudyData();
    } else {
      await getStudyData();
      setViewerReadyToLoad(true);
    }
    setLoaderRunning(false);
  };

  

  useEffect(() => {
    if(isLinkAuthenticated){
      openSharedStudyViewerAfterAuth();
    }
  }, [isLinkAuthenticated]);

    const checkBypassAndProceed = async (token, isActiveData) => {
  try {
    const res = await checkBypass(token, isActiveData);

    const status = res?.status;
    const bypass = res?.data?.data === true;
    const message = res?.data?.message;

    // 🚫 Study not found / access denied
    if (status === 404 || status === 403) {
      setLoaderRunning(false);
      ref.current?.complete();

      setIsLinkAuthenticated(true); // allow render

      setShowSharedViewer(false);
      setViewerReadyToLoad(false);

      setIsAccessAllowed(false);
      setNotAllowedMessage(
        message || "You are not allowed to view this study"
      );
      return;
    }

    // ✅ Bypass allowed
    if (bypass) {
      setIsLinkAuthenticated(true);
      return;
    }

    // 🔐 Password required (200 + data=false)
    setLoaderRunning(false);
    ref.current?.complete();

  } catch (e) {
    // This will now be ONLY true network / JS errors
    console.error("Bypass check failed:", e);
    setAuthError("Unable to verify link. Please try again.");
    setLoaderRunning(false);
  }
};



  const openSharedStudyViewer = async () => {
    setSharedViewer(true);
    setLoaderRunning(true);
    ref.current.continuousStart();
    if (getEnv("REACT_APP_VDC_PLATFORM") === "true") {
      getStudyData();
      setIsLinkAuthenticated(true);
    } else {
          console.log("Current URL:", currentUrl);
    const urlObj = new URL(currentUrl);
    const params = new URLSearchParams(urlObj.search);
    const token = params.get("id") || "";
    setBasicToken(token);
    console.log("Basic Token (from URL):", token);
    checkBypassAndProceed(token, /* isActiveData: */ true);
    }
    // setLoaderRunning(false);
  };

  useEffect(() => {
    openSharedStudyViewer();
  }, []);

  const fetchAdvanceViewerUrl = async (vdc = false) => {
    // setLoaderRunning(true);
    ref.current.continuousStart();
    if (
      advanceViewerAvailable &&
      advanceViewerUrl != null &&
      advanceViewerUrl != "" &&
      !vdc //need to generate new url for vdc, so bypassing this condition
    ) {
      ref.current.complete();
      return;
    }
    const response = await getAdvanceViewerUrl(searchParams.get("id"), isActiveDataParam);
    console.log(response);
    if (response.status === 200) {
      setAdvanceViewerAvailable(true);
      setAdvanceViewerUrl(response.data.data);
      ref.current.complete();
      if (vdc) {
        return response.data.data;
      }
    } else {
      setAdvanceViewerAvailable(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.adv-viewer-not-available");
        return newItem;
      });
      ref.current.complete();
      if (vdcPlatform) return "";
    }
  };

  useEffect(() => {
    if (sharedDefaultViewer != -1) {
      if (sharedDefaultViewer == SHARED_VIEWER.ADVANCE) {
        if (
          getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
          switchViewer != null &&
          switchViewer == "true"
        ) {
          setSharedDefaultViewer(-1);
          let myPromise = fetchAdvanceViewerUrl(true);
          myPromise.then((url) => {
            console.log(url);
            //window.open(url, "_blank");
            window.open(getSafeRedirectUrl(url), "_blank");
          });
        } else {
          window.location.replace(sharedAdvanceViewerURL);
        }
      } else {
        if (
          getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
          switchViewer != null &&
          switchViewer == "true"
        ) {
          const urlObj = new URL(currentUrl);
          const params = new URLSearchParams(urlObj.search);
          params.delete("switchViewer");
          params.set("openViewer", 1);
          urlObj.search = params.toString();

          let url = urlObj.toString();
          setSharedDefaultViewer(-1);
          setShowSharedViewer(true);

          //window.open(url, "_blank");
          window.open(getSafeRedirectUrl(url), "_blank");        
        } else {
          setShowSharedViewer(true);
          setViewerReadyToLoad(true);
        }
      }
    }
  }, [sharedDefaultViewer]);

const getSafeRedirectUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) {
      return parsed.pathname + parsed.search + parsed.hash;
    }
  } catch (e) {}
  return "/";
};
  useEffect(() => {
    if (
      getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
      switchViewer != null &&
      switchViewer == "true"
    ) {
      const urlObj = new URL(currentUrl);
      const params = new URLSearchParams(urlObj.search);
      params.delete("switchViewer");
      params.set("openViewer", 0);
      urlObj.search = params.toString();

      const advanceUrl = urlObj.toString();
      setAdvanceStudyURL(advanceUrl);

      params.delete("openViewer");
      params.set("openViewer", 1);
      urlObj.search = params.toString();
      const basicUrl = urlObj.toString();
      setBasicStudyURL(basicUrl);
    }

  }, []);

  useEffect(() => {
    if (viewerReadyToLoad) {
      if (advanceViewer) {
        fetchAdvanceViewerUrl(vdcPlatform);
      } else {
        setLoaderRunning(true);
        ref.current.continuousStart();
        setTimeout(() => {
          setLoaderRunning(false);
          ref.current.complete();
        }, 1000);
      }
    }
  }, [advanceViewer]);

  // Pause the thumbnail background preload while the Advance (MedDream iframe)
  // viewer is showing — the thumbnail panel is hidden, so there is nothing to
  // preload for. Switching back to Basic resumes it from where it stopped.
  // ThumbnailState reads prefetchPaused and aborts in-flight downloads on pause.
  useEffect(() => {
    setPrefetchPaused(advanceViewer);
  }, [advanceViewer]);

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      password: "",
    },
    // enableReinitialize: true,
    // validationSchema: isEmailChecked === true ? ShareStudyLinkSchema : null,
    onSubmit: async (values) => {
      // if (values.urlPassword == props.values.studyShareUrlPassword) {
      //   setIsLinkAuthenticated(true);
      // }
      handlePasswordSubmit(values.password);
    }
  });

  const handleClose = () => {
    window.location.href = "about:blank"; // or your homepage
  };

  const hideAlertSuccessModal = () => {
    setAdvanceViewer(false);
    setAlertSuccessModal(() => {
      const newItem = { ...alertSuccessModal };
      newItem.show = false;
      newItem.heading = "Alert";
      newItem.isError = false;
      newItem.isSuccess = false;
      newItem.isWarning = true;
      newItem.description = t("string-literals.adv-viewer-not-available");
      return newItem;
    });
  };

  let PrimaryButtonList = [
    {
      title: t("button.submit"),
      onclick: handleSubmit,
    }
  ];
  let DefaultButtonList = [
    {
      title: t("button.close"),
      onclick: handleClose
    }
  ];

  useEffect(() => {
    document.addEventListener("gesturestart", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gesturechange", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gestureend", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });
  }, []);

  const onKeyPress = async (event) => {
    console.log("Inside the OnkeyPress activeViewportIndex:", activeViewportIndex);
    console.log("Viewport Series Data:", viewportSeriesData);
    console.log("Viewport Data at Index:", viewportSeriesData?.[activeViewportIndex]);
    console.log("Stack Data:", viewportSeriesData?.[activeViewportIndex]?.stack);
    console.log("Thumbnail Image IDs:", viewportSeriesData?.[activeViewportIndex]?.stack?.thumbnailImageIds);
    console.log("Total Images:", viewportSeriesData?.[activeViewportIndex]?.stack?.thumbnailImageIds?.length);
    document.addEventListener("keydown", (event) => {
      console.log(`Key Pressed: ${event.key} | Code: ${event.keyCode}`);
    });
    const { target, keyCode } = event;

    const srcElement = event.srcElement || event.target;
    const isEditableTarget =
      srcElement?.isContentEditable ||
      srcElement?.nodeName === "INPUT" ||
      srcElement?.nodeName === "TEXTAREA" ||
      srcElement?.closest?.(
        '[contenteditable="true"], .fr-element, .fr-wrapper, .fr-box'
      );

    if (isEditableTarget) {
      return;
    }

    if (target.nodeName !== 'INPUT' && target.nodeName !== 'TEXTAREA' && target.nodeName !== 'SELECT') {
      switch (keyCode) {
        case 27: //ESC
          if (isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            handleDefaultToolChange();
          } else {
            setPreviousActiveTool(activeTool);
            handleDefaultToolChange();
          }
          break;
        case 73: // 'I' - Invert Image
          setInvert(activeViewportIndex);
          break;
        case 72: // 'H' - Flip Horizontally
          FlipHorizontally(activeViewportIndex);
          break;
        case 86: // 'V' - Flip Vertically
          FlipVertically(activeViewportIndex);
          break;
        case 48: //NORMAL WW WC
          console.log("Pressed 0 ");
          console.log("Pressed 0 - Checking if resetVOILUTRange() is called");
          console.log("Calling resetVOILUTRange with range:", initialVOIRange);
          resetVOILUTRange(activeViewportIndex, initialVOIRange, isMPRActive);
          console.log("resetVOILUTRange() executed successfully");
          break;
        case 49: // '1' - Abdomen
          setVOILUTRange(activeViewportIndex, 400, 60);
          break;
        case 50: // '2' - Angio
          setVOILUTRange(activeViewportIndex, 600, 300);
          break;
        case 51: // '3' - Bone
          setVOILUTRange(activeViewportIndex, 1500, 300);
          break;
        case 52: // '4' - Brain
          setVOILUTRange(activeViewportIndex, 80, 40);
          break;
        case 53: // '5' - Chest
          setVOILUTRange(activeViewportIndex, 400, 40);
          break;
        case 54: // '6' - Lungs
          setVOILUTRange(activeViewportIndex, 1500, -400);
          break;
        case 38: //UP
          console.log("Inside the 'UP key' Before calling the UP key : ", viewportSeriesData)
          console.log(`Inside the "UP key" Before calling the getViewport method the activeViewportIndex is : ${activeViewportIndex}`);
          const activeViewport1 = await getViewport(activeViewportIndex);
          console.log("after calling the UP key : ", viewportSeriesData)
          console.log(`After getting activeViewport1 from get Viewport value is : ${activeViewport1}`);
          console.log("Present inside the activeViewport1", activeViewport1);
          const currentImage1 = activeViewport1.getCurrentImageIdIndex();
          console.log(`activeViewport1.getCurrentImageIdIndex() the currentImage1 value will be : ${currentImage1}`);
          if (currentImage1 !== 0) {
            activeViewport1.setImageIdIndex(currentImage1 - 1);
          }
          break;
        case 40: //DOWN
          console.log(`Inside the activeViewport2 having activeViewportIndex as : ${activeViewportIndex}`);
          const activeViewport2 = await getViewport(activeViewportIndex);
          console.log(`After getting getViewport the activeViewport2 value will be : ${activeViewport2}`);
          console.log("Present inside the activeViewport2", activeViewport2);
          const currentImage2 = activeViewport2.getCurrentImageIdIndex();
          console.log(`activeViewport2.getCurrentImageIdIndex() the currentImage2 value will be : ${currentImage2}`);
          console.log(
            "Total Images:",
            viewportSeriesData[activeViewportIndex].stack.thumbnailImageIds.length
          );
          console.log(
            "Image IDs Array:",
            viewportSeriesData[activeViewportIndex].stack.thumbnailImageIds
          );
          if (currentImage2 !== viewportSeriesData[activeViewportIndex].stack.thumbnailImageIds.length - 1) {
            activeViewport2.setImageIdIndex(currentImage2 + 1);
          }
          break;
        case 83:
          openSeriesMenu();
          if (!reportMenu && activeTool !== DEFAULT_TOOL) {
            setPreviousActiveTool(activeTool);
            setActiveTool(DEFAULT_TOOL);
            break;
          }
          break;
        case 39: //ARROW RIGHT
          console.log("Arrow right ================== with activeThumbnailIndex", activeThumbnailIndex);
          console.log("StudyData inside the right arrow", studyData);
          if (!reportMenu) {
            if (activeThumbnailIndex === studyData?.stacks.length - 1) {
              break;
            }
            let activeThumbnailIndexNumber = Number(activeThumbnailIndex);
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexNumber + 1);
          }
          break;
        case 37: //ARROW LEFT
          if (!reportMenu) {
            if (activeThumbnailIndex === 0) {
              break;
            }
            let activeThumbnailIndexNumber = Number(activeThumbnailIndex);
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexNumber - 1);
          }
          break;
        case 69: // 'e' for Elliptical
          setPreviousActiveTool(activeTool);
          handleDefaultToolChange(); // disables current active tool
          setActiveTool("EllipticalROI");
          break;

        case 76: // 'l' for Length
          setPreviousActiveTool(activeTool);
          handleDefaultToolChange(); // disables current active tool
          setActiveTool("Length");
          break;
        case 121: // 'y' — toggle primary mouse: Stack Scroll
          togglePrimaryMouseAssignmentForTool(StackScrollTool.toolName);
          break;
        case 87: // 'w' — toggle primary mouse: Window / Level
          togglePrimaryMouseAssignmentForTool(WindowLevelTool.toolName);
          break;
        case 90: // 'z' — toggle primary mouse: Zoom
          togglePrimaryMouseAssignmentForTool(ZoomTool.toolName);
          break;
        case 84: // 't' — Pan
          togglePrimaryMouseAssignmentForTool(PanTool.toolName);
          break;
        default:
          break;
      }
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);
    return () => {
      window.removeEventListener("keydown", onKeyPress);
    };
  });
  useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      // e.preventDefault();
      purgeCache();
    });

    return () => {
      window.removeEventListener("beforeunload", (e) => {
        // e.preventDefault();
        purgeCache();
      });
    };
  });

  const modalDetails = {
    header: <ModalHeader updatedModal={true} showPatientDetails={false} heading={t("share-study.title-password")} handleCancel={handleClose} />,
    footer: <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={PrimaryButtonList} />,
    body: <ShareStudyLinkPasswordValidateBody values={values} handleChange={handleChange} errors={errors} authError={authError}/>,
    width: "500px",
    height: "360px"
  }

  if (!isLinkAuthenticated) {
    return (
      <>
        <ModalMain showModal={true} modalDetails={modalDetails} />

      </>
    )
  }
  return (
    <>

      {getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
        switchViewer === "true" &&
        isAccessAllowed && (
          <ViewerPage
            showSharedViewer={showSharedViewer}
            setShowSharedViewer={setShowSharedViewer}
            sharedDefaultViewer={sharedDefaultViewer}
            setSharedDefaultViewer={setSharedDefaultViewer}
            patientStudyData={patientStudyData}
            basicStudyURL={basicStudyURL}
            advanceStudyURL={advanceStudyURL}
          />
        )}
      {!isAccessAllowed && notAllowedMessage !== "" ? (
        <NotAllowed msg={notAllowedMessage} />
      ) : (
        cornerstoneInitialized && showSharedViewer &&
        viewerReadyToLoad && (
          <>
            {showSharedTopBar &&
              <SharedTopBar
                openReport={openReportMenu}
                openSeries={openSeriesMenu}
                setAdvanceViewer={setAdvanceViewer}
                advanceViewerAvailable={advanceViewerAvailable}
                advanceViewer={advanceViewer}
              />
            }

            {alertSuccessModal?.show && (
              <AlertSuccessModal
                isError={alertSuccessModal.isError}
                isWarning={alertSuccessModal.isWarning}
                isSuccess={alertSuccessModal.isSuccess}
                heading={alertSuccessModal.heading}
                description={alertSuccessModal.description}
                hideModal={hideAlertSuccessModal}
                isModalOpen={alertSuccessModal?.show}
              />
            )}
            <div
              id="viewport-div"
              style={{
                // height: "92%",
                height: `${viewportOldState.largeImage ? "100%" : "calc(100% - var(--topbar-container-height, 50px))"}`,
              }}
            >
              {!advanceViewer && isMobile ? (
                <>
                  <div
                    className={
                      `${isMobile
                        ? "first-comes mobile-sidebar-left mobile-thumbnail-list"
                        : "first-comes sidebarMenu sidebar-left"
                      }` + (seriesMenu === true ? " sidebar-open-left" : "")
                    }
                  >
                    {dataGathered && (
                      <ThumbnailList
                        patientName={patientStudyData?.patientName}
                        patientId={patientStudyData?.patientId}
                        studyData={studyData}
                        priorStudyData={priorStudyData}
                        priors={false}
                      />
                    )}
                  </div>
                  <div
                    className="h100"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    {/* flex:1 so the viewport shrinks and the bottom .viewer-mobile-toolbar
                        (flex-shrink:0) keeps its full height instead of being clipped. */}
                    <div style={{ flex: 1, minHeight: 0 }}>
                      <div className="viewer-viewport-section h100">
                        <div className="main-container h100 w100">
                          <div
                            style={{
                              border: `${isMPRActive || isCompareActive
                                  ? "1px solid #FFB801"
                                  : ""
                                }`,
                              borderRadius: `${isMPRActive || isCompareActive ? "10px" : ""
                                }`,
                              width: "100%",
                              margin: "0px 0.25%",
                              height: "99.5%",
                              position: "relative",
                            }}
                          >
                            <ViewportLayout priors={false} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="viewer-mobile-toolbar">
                      <MobileToolbar />
                    </div>
                    <div
                      className={`popup ${isUserInfoClicked ? "viewer-open" : ""
                        }`}
                    >
                      <MobileOverlayBottomSheet
                        viewportData={viewportSeriesData[0]}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="viewer-thumbnail-section"
                    style={{
                      height: "100%",
                    }}
                  // onTouchStart={handleTouchStart}
                  // onTouchEnd={handleTouchEnd}
                  >
                    <div
                      style={{
                        height: "100%",
                        paddingBottom: "0",
                      }}
                      className={
                        `${isMobile
                          ? "first-comes mobile-sidebar-left mobile-thumbnail-list"
                          : "first-comes sidebarMenu sidebar-left"
                        }` + (seriesMenu === true ? " sidebar-open-left" : "")
                      }
                    >
                      {dataGathered && (
                        <ThumbnailList
                          patientName={patientStudyData?.patientName}
                          patientId={patientStudyData?.patientId}
                          studyData={studyData}
                          priorStudyData={priorStudyData}
                          priors={false}
                        />
                      )}
                    </div>
                    <div
                      className="viewer-viewport-container"
                      style={{
                        opacity: `${isMobile && seriesMenu ? "0.5" : 1}`,
                        // padding: `${isMobile ? "0" : "5px"}`,
                        width: `${isMobile
                            ? "calc(100vw - 200px)"
                            : "calc(100vw - 150px)"
                          }`,
                      }}
                    >
                      <div
                        className="viewer-viewport-section h100"
                        style={{ flex: "1 1 auto", minHeight: 0 }}
                      >
                        <div
                          className="main-container h100 w100"
                          style={{ opacity: `${viewerOpacity}` }}
                        >
                          <div
                            style={{
                              border: `${isMPRActive ? "1px solid #FFB801" : ""
                                }`,
                              borderRadius: `${isMPRActive ? "10px" : ""}`,
                              width: `${isMobile ? "99.9%" : "99.5%"}`,
                              margin: "0px 0.25%",
                              height: "99.5%",
                              position: "relative",
                            }}
                          >
                            {contextMenuOpen.open && (
                              <ContextMenu
                                mouseEvt={contextMenuOpen.mouseEvt}
                                data={contextMenuOpen.data}
                              />
                            )}
                            {/* {thumbnailLoaded && ( */}
                            <ViewportLayout priors={false} initialVOI={setInitialVOIRange} />
                            {showShortcutModal && <ShortcutKeyModal isSharedStudyViewer={true} />}
                            {/* )} */}
                            {isMPRActive && (
                              <div className="viewer-viewport-mpr-tag">
                                {t("mpr.mpr-mode")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {!isMobile &&
                        imageLoadedOnViewport &&
                        (isOutlineEnabled ||
                          isHeatMapEnabled ||
                          (NONXRAYMODALITIES.includes(studyModality) &&
                            aiProcessed >= 1)) && (
                          <div className="viewer-outline-heatmap-container">
                            <span className="viewer-outline-heatmap-text viewer-outline-heatmap-text-width">
                              <CustomToolTipHost
                                id="viewer-ai-text"
                                content={t(
                                  "string-literals.ai-disclaimer"
                                )}
                              >
                                {t("string-literals.ai-disclaimer")}
                              </CustomToolTipHost>
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </>
              )}
              {advanceViewer && advanceViewerAvailable && (
                <>
                  <div className="shared-advance-viewer-container">
                    <AdvanceViewerIframe advanceViewerUrl={advanceViewerUrl} />
                  </div>
                </>
              )}
            </div>
          </>
        )
      )}
    </>
  );
};

export default SharedStudyViewer;
